import React, { useEffect, useState, useRef } from 'react';

import { useTheme } from '@material-ui/core/styles';

//tabs
import SwipeableViews from 'react-swipeable-views'; //paquete installado manual(npm i react-swipeable-views)
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import PaymentIcon from '@material-ui/icons/Payment';
import Button from 'components/CustomButtons/Button.js';
import { makeStyles } from '@material-ui/core/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import selectStyles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js';

import { WithApp } from 'contexts/appContext';
import Transfer from './TabContent/Transfer';
import Check from './TabContent/Check';
import { wsCreate } from 'services/WService';
import Cash from './TabContent/Cash';
import { Divider, InputLabel, TextField } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService';
import moment from 'moment';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles({
  ...styles,
  ...selectStyles,
  grid: {
    fontWeight: 'bold',
    textAlign: 'end'
  },
  div: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'space-around',
    flexWrap: 'nowrap',
    alignItems: 'baseline'
  },
  totalPay: {
    marginRight: '10px',
    fontSize: '17px'
  },
  input: {
    fontWeight: 'bold'
  }
});
export default WithApp(function PaymentRDocDetail(props) {
  const classes = useStyles();
  const { bPartnerId, bPartner, totalPay, docSelects, showNotify, setHandlePay, reload } = props;

  const formGeneral = useRef();

  const [methodPay, setMethodPay] = useState({
    CH: false,
    TR: false,
    CK: false,
    LT: false
  });
  const [payment, setPayment] = useState(totalPay);
  const [formPositions, setFormPositions] = useState([]);
  const [calAmount, setCalAmount] = useState(0);
  const [valueTotal, setValueTotal] = useState(0);
  const [dataPayment, setDataPayment] = useState({});

  //#region  tabs
  const claseStyleTab = useStyleTabs();
  const [value, setValue] = useState(0);
  const themeTab = useTheme();

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const tabsComponent = [
    {
      component: Cash,
      type: 'CH',
      disabled: Object.keys(dataPayment).includes('CH') ? false : payment > 0 ? false : true,
      label: 'Fondo en efectivo'
    },
    {
      component: Transfer,
      type: 'TR',
      disabled: Object.keys(dataPayment).includes('TR') ? false : payment > 0 ? false : true,
      label: 'Transferencia bancaria'
    },
    {
      component: Check,
      type: 'CK',
      disabled: Object.keys(dataPayment).includes('CK') ? false : payment > 0 ? false : true,
      label: 'Cheque'
    },
    { component: Check, type: 'LT', disabled: true, label: 'Letras' }
  ];
  //#endregion tabs

  //#region listado de bancos
  const [banks, setBanks] = useState([]);
  const [accounts, setAccounts] = useState([]);
  async function listBanks() {
    let response = await wsGetAll('base/bank');
    if (response.success) {
      setBanks(response.data);
    }
  }

  async function listAccounts() {
    let response = await wsGetAll('pymt/transfer-accounts');
    if (response.success) {
      setAccounts(response.data);
    }
  }

  //#endregion

  // #region funciones de procesos internos
  function calTotal(data) {
    let newObj = {};
    for (let prop in data) {
      if (prop !== 'type') {
        newObj = { ...newObj, ...data[prop] };
      }
    }
    let sumTotals = 0;
    for (let prop in newObj) {
      if (prop.includes('Sum')) {
        newObj = { ...newObj, [prop]: parseFloat(newObj[prop]).toFixed(2) };
        sumTotals += parseFloat(newObj[prop]);
      }
    }
    setCalAmount(sumTotals);
    return { newObj, sumTotals };
  }

  function handleMethod(type, status) {
    setMethodPay({ ...methodPay, [type]: status });
  }

  function processPayment(type, dataComponent) {
    let newData = {};
    if (type === 'CH' || type === 'TR') {
      for (let input of dataComponent.current.querySelectorAll('[name]')) {
        newData[input.name] = input.value;
      }
    } else {
      newData = dataComponent;
    }

    let totalCal = calTotal({ [type]: { ...newData } }).sumTotals;
    if (type && !methodPay[type]) {
      setDataPayment({ ...dataPayment, [type]: { ...newData }, type: type });
      setPayment(parseFloat((payment - totalCal).toFixed(2)));
      showNotify('Método de pago agregado');
    } else {
      showNotify('Método de pago retirado', 'warning');
      setPayment(parseFloat((payment + totalCal).toFixed(2)));
      delete dataPayment[type];
      delete dataPayment.type;
      setDataPayment(dataPayment);
      handleMethod(type, false);
    }
  }

  function helperText(total) {
    let text = '';
    if (Object.keys(dataPayment).length > 0) {
      text = '...';
    } else {
      if (total > totalPay) {
        text = 'Pasó: ' + (total - totalPay).toFixed(2);
      } else if (total == totalPay) {
        text = 'Completo';
      } else {
        text = 'Falta: ' + (totalPay - total).toFixed(2);
      }
    }

    return text;
  }
  //#endregion

  // #region alerta antes de procesar
  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirmPay(data, isComplete) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={
          isComplete ? '¿Está seguro de procesar el pago?' : '¡Está realizando un pago parcial!'
        }
        onConfirm={() => {
          savePayment(data);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {isComplete ? '' : '¿Esta seguro de continuar?'}
      </SweetAlert>
    );
  }
  // #region

  function validationData(data) {
    let dataGeneral = {};
    for (let input of formGeneral.current.querySelectorAll('[name]')) {
      dataGeneral[input.name] = input.value;
    }

    if (Object.keys(data).length > 2) {
      data.type = 'MT';
    }
    if (valueTotal > 0) {
      if (valueTotal.toFixed(2) != totalPay.toFixed(2)) {
        showNotify('El total a pagar no coincide con la suma de los documentos', 'warning');
      } else {
        confirmPay({ ...calTotal(data).newObj, ...dataGeneral, type: data.type }, calcSaldo());
      }
    } else {
      if (calTotal(data).sumTotals.toFixed(2) !== totalPay.toFixed(2)) {
        showNotify('La suma de los montos de pago no coincide con el total a pagar', 'warning');
      } else {
        confirmPay({ ...calTotal(data).newObj, ...dataGeneral, type: data.type }, calcSaldo());
      }
    }
  }

  async function savePayment(data) {
    /* console.log({ ...data, base_business_partner_id: bPartnerId, documents: docSelects }); */
    let response = await wsCreate(
      bPartner.CardType === 'C' ? 'pymt/received-payment' : 'pymt/accomplished-payment',
      { ...data, base_business_partner_id: bPartnerId, documents: docSelects }
    );
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  function calcSaldo() {
    let sumSaldo = 0;
    for (let obj of docSelects) {
      if (obj !== undefined) {
        sumSaldo += obj.Saldo;
      }
    }
    if (parseFloat(sumSaldo).toFixed(2) == parseFloat(totalPay).toFixed(2)) {
      return true; // pago Completo
    } else {
      return false; //No pago Completo
    }
  }

  useEffect(() => {
    setPayment(totalPay);
    listBanks();
    listAccounts();
  }, [totalPay]);

  useEffect(() => {
    let formEntity = 'pymt/accomplished-payment/form-positions';
    if(bPartner.CardType === 'C'){
      return;
      // formEntity = 'pymt/received-payment/form-positions';
    }
    wsGetAll(formEntity).then(res => {
      if(res.success){
        setFormPositions(res.data);
        console.log(res.data);
      }
    });
  }, []);

  return (
    <div className={claseStyleTab.root}>
      {alert}
      <GridContainer style={{ marginBottom: '15px' }}>
        <GridItem xs={12} sm={3} md={2}>
          <div className={classes.div}>
            <TextField
              key={totalPay + calAmount}
              fullWidth
              label="Total a pagar"
              type="number"
              defaultValue={valueTotal || totalPay.toFixed(2)}
              onChange={(e) => {
                setPayment(parseFloat(e.target.value));
                setHandlePay(parseFloat(e.target.value));
                setValueTotal(parseFloat(e.target.value));
              }}
              margin="normal"
              helperText={helperText(valueTotal)}
              InputProps={{
                className: classes.input,
              }}
              onKeyPress={(e) => {
                var key = window.event ? e.which : e.keyCode;
                if (key === 101) {
                  return e.preventDefault();
                }
              }}
              inputProps={{
                min: 0,
                step: 0.0001,
              }}
              disabled={Object.keys(dataPayment).length > 0 ? true : false}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={6} md={8}>
          <form
            ref={formGeneral}
            id="formSaveData"
            onSubmit={(e) => {
              e.preventDefault();
              validationData(dataPayment);
              /* if (calcSaldo()) {
                validationData(dataPayment);
              } else {
                confirmPay(dataPayment);
              } */
            }}
          >
            <GridContainer>
              <AllowedGuard
                permission={
                  bPartner.CardType === 'C'
                    ? ConstantPermissions.PYMT_RECEIVED_PAYMENTS_DOCDATE
                    : ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_DOCDATE
                }
              >
                <GridItem xs={6} md={4}>
                  <TextField
                    type="date"
                    label="Fec. contable"
                    name="DocDate"
                    fullWidth
                    defaultValue={moment().format('YYYY-MM-DD') || ''}
                    margin="normal"
                    required
                  />
                </GridItem>
              </AllowedGuard>

              {bPartner.CardType === 'S' && (
                <GridItem xs={6} md={4}>
                  <FormControl
                    fullWidth
                    className={classes.selectFormControl + ' ' + classes.formControlMargins}
                  >
                    <InputLabel>Posición formulario</InputLabel>
                    <Select
                      color="primary"
                      name="CFWId"
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                    >
                      {formPositions.map((item, index) => {
                        return (
                          <MenuItem key={item.CFWId} value={item.CFWId}>
                            {item.CFWName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              <GridItem xs={6} md={4}>
                <TextField
                  multiline
                  label="Comentario"
                  name="Comments"
                  fullWidth
                  defaultValue=""
                  margin="normal"
                  required
                />
              </GridItem>
            </GridContainer>
          </form>
        </GridItem>
        <GridItem xs={12} sm={3} md={2} style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            type="submit"
            fullWidth
            form="formSaveData"
            color={props.themeContext.buttonColorSuccess}
          >
            <PaymentIcon /> Procesar
          </Button>
        </GridItem>
      </GridContainer>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          textColor="secondary"
          aria-label="Tabs"
          indicatorColor="secondary"
        >
          {tabsComponent.map((item, i) => {
            return <Tab key={i} label={item.label} {...indexTab(i)} disabled={item.disabled} />;
          })}
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {tabsComponent.map((item, i) => {
          return (
            <TabPanel key={i} value={value} index={i} dir={themeTab.direction}>
              <item.component
                banks={banks}
                type={item.type}
                amountPay={payment}
                bPartnerId={bPartnerId}
                docSelects={docSelects}
                showNotify={showNotify}
                dataPayment={dataPayment}
                setDataPayment={setDataPayment}
                methodPay={methodPay}
                handleMethod={handleMethod}
                processPayment={processPayment}
                accounts={accounts}
              />
            </TabPanel>
          );
        })}
      </SwipeableViews>
    </div>
  );
});
